
import React from 'react';
import { Button } from "@/components/ui/button";
import { 
  ThumbsUp, 
  ThumbsDown, 
  Reply, 
  MoreHorizontal, 
  BookmarkPlus
} from 'lucide-react';
import { cn } from "@/lib/utils";

interface CommentActionsProps {
  liked: boolean;
  disliked: boolean;
  likeCount: number;
  dislikeCount: number;
  saved: boolean;
  isReply: boolean;
  onLike: () => void;
  onDislike: () => void;
  onReply: () => void;
  onSave: () => void;
}

const CommentActions: React.FC<CommentActionsProps> = ({
  liked,
  disliked,
  likeCount,
  dislikeCount,
  saved,
  isReply,
  onLike,
  onDislike,
  onReply,
  onSave
}) => {
  return (
    <div className="flex items-center gap-4 mt-2 text-sm">
      <Button 
        variant="ghost" 
        size="sm" 
        className={cn("h-auto p-0", liked && "text-primary")}
        onClick={onLike}
      >
        <ThumbsUp className={`h-4 w-4 mr-1 ${liked ? 'fill-current' : ''}`} />
        {likeCount}
      </Button>
      
      <Button 
        variant="ghost" 
        size="sm" 
        className={cn("h-auto p-0", disliked && "text-destructive")}
        onClick={onDislike}
      >
        <ThumbsDown className={`h-4 w-4 mr-1 ${disliked ? 'fill-current' : ''}`} />
        {dislikeCount}
      </Button>
      
      <Button 
        variant="ghost" 
        size="sm" 
        className="h-auto p-0 text-muted-foreground"
        onClick={onReply}
      >
        <Reply className="h-4 w-4 mr-1" />
        Reply
      </Button>
      
      <Button 
        variant="ghost" 
        size="sm" 
        className={cn("h-auto p-0 text-muted-foreground", saved && "text-primary")}
        onClick={onSave}
      >
        <BookmarkPlus className={`h-4 w-4 mr-1 ${saved ? 'fill-current' : ''}`} />
        Save
      </Button>
      
      <Button variant="ghost" size="sm" className="h-auto p-0 text-muted-foreground ml-auto">
        <MoreHorizontal className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default CommentActions;
